export const settingsTableHeader = [
  // { title: "الاسم", key: "text_AR" },
  { title: 'الاسم بالعربية', key: 'text_AR' },
  { title: 'تم الإنشاء بواسطة', key: 'createdBy' },
];
